var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoals = function SvgGoals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2.5,
    d: "M12 11.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.25 12.5a9.25 9.25 0 0 1-18.5 0c0-1.499.356-2.912.987-4.162a.75.75 0 1 0-1.34-.676A10.7 10.7 0 0 0 1.25 12.5c0 5.937 4.813 10.75 10.75 10.75s10.75-4.813 10.75-10.75S17.937 1.75 12 1.75c-2.93 0-5.587 1.173-7.525 3.073l1.05 1.071A9.22 9.22 0 0 1 12 3.25a9.25 9.25 0 0 1 9.25 9.25",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 12.5a5.25 5.25 0 1 1-10.335-1.313.75.75 0 1 0-1.452-.374 6.75 6.75 0 1 0 1.73-3.05L8.26 8.814A5.23 5.23 0 0 1 12 7.25a5.23 5.23 0 0 1 3.658 1.484A5.23 5.23 0 0 1 17.25 12.5",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M12 12.5 3.5 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 4.5h.75v.75H4zm-.75-3a.75.75 0 0 1 1.5 0zM1 5.25a.75.75 0 0 1 0-1.5zm2.25-.75v-3h1.5v3zM1 3.75h3v1.5H1z"
  })));
};
export default SvgGoals;